import { VariationSettings } from '../classes';

export function getCssFontVariationSettings(
    variationSettings?: VariationSettings
): string {
    if (!variationSettings) return '';

    const axes = Object.keys(variationSettings);
    const settings = axes.map((key) => `"${key}" ${variationSettings[key]}`);
    const fontVariationSettings = settings.join(', ');
    return fontVariationSettings || 'inherit';
}
